import { Link } from "react-router-dom";
import { MessageCircle, ArrowUpRight } from "lucide-react";
import { fmtPrice, fmtKm, STATUS_LABELS, STATUS_COLORS, whatsappVehicleUrl } from "@/lib/constants";

export default function VehicleCard({ v }) {
  const label = `${v.brand} ${v.model}`;
  return (
    <article
      data-testid={`vehicle-card-${v.id}`}
      className="group bg-[#141414] border border-white/10 rounded-2xl overflow-hidden transition-[transform,border-color,box-shadow] duration-300 md:hover:-translate-y-1 md:hover:border-[#FF1E27]/40 md:hover:shadow-[0_10px_30px_rgba(255,30,39,0.15)]"
    >
      <Link to={`/vehicule/${v.id}`} data-testid={`vehicle-card-link-${v.id}`} className="block relative aspect-[16/10] overflow-hidden bg-[#1A1A1A]">
        {v.images?.[0] ? (
          <img
            src={v.images[0]}
            alt={label}
            loading="lazy"
            decoding="async"
            className="spotlight-img w-full h-full object-cover md:group-hover:scale-105 transition-transform duration-700"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-zinc-600 font-spec text-xs uppercase tracking-widest">
            Photo à venir
          </div>
        )}
        <span className={`absolute top-3 left-3 text-[11px] font-spec uppercase tracking-widest px-2.5 py-1 rounded-full border bg-black/75 ${STATUS_COLORS[v.status] || STATUS_COLORS.disponible}`}>
          {STATUS_LABELS[v.status] || "Disponible"}
        </span>
      </Link>

      <div className="p-5 sm:p-6">
        <h3 className="font-display text-lg sm:text-xl font-bold text-white leading-tight">{label}</h3>
        <div className="mt-3 grid grid-cols-4 gap-2 text-center">
          {[
            [v.year, "Année"],
            [fmtKm(v.km), "Km"],
            [v.fuel, "Énergie"],
            [v.transmission, "Boîte"],
          ].map(([val, lab]) => (
            <div key={lab} className="bg-white/5 rounded-lg px-1 py-2">
              <p className="text-[11px] sm:text-xs font-semibold text-white truncate">{val}</p>
              <p className="text-[9px] font-spec uppercase tracking-widest text-zinc-500 mt-0.5">{lab}</p>
            </div>
          ))}
        </div>

        <div className="mt-4 flex items-end justify-between gap-3">
          <p data-testid={`vehicle-card-price-${v.id}`} className="font-display text-2xl font-black text-[#FF1E27]">
            {fmtPrice(v.price)}
          </p>
          <div className="flex items-center gap-2">
            <a
              data-testid={`vehicle-card-whatsapp-btn-${v.id}`}
              href={whatsappVehicleUrl(label)}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`WhatsApp à propos de ${label}`}
              className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center text-zinc-300 hover:text-white hover:border-[#FF1E27] transition-colors"
            >
              <MessageCircle className="w-4 h-4" />
            </a>
            <Link
              data-testid={`vehicle-card-details-btn-${v.id}`}
              to={`/vehicule/${v.id}`}
              className="h-10 px-4 rounded-full bg-white text-black text-sm font-semibold flex items-center gap-1.5 hover:bg-[#FF1E27] hover:text-white transition-colors"
            >
              Voir <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>
    </article>
  );
}
